/**
 * Portal CrudManager configuration utilities.
 *
 * Provides centralized access to configuration values that may be set
 * by the Laravel backend via Inertia shared data or window globals.
 */

/**
 * Get the configured route prefix for CRUD routes.
 * Falls back to 'crud' if not configured.
 *
 * The route prefix can be set via:
 * - window.crud_route_prefix (set by Laravel's blade template or middleware)
 * - Default: 'crud'
 */
export function getRoutePrefix(): string {
  return (
    (window as Window & { crud_route_prefix?: string }).crud_route_prefix ??
    "crud"
  );
}

/**
 * Build a CRUD route URL with the configured prefix.
 *
 * @param path - The path segment after the prefix (e.g., 'global-search', '{model}')
 * @returns The full URL with the configured prefix
 */
export function buildCrudUrl(path: string): string {
  const prefix = getRoutePrefix();
  const cleanPath = path.startsWith("/") ? path.slice(1) : path;
  return `/${prefix}/${cleanPath}`;
}
